import React from 'react';

export const AddIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={`${className} stroke-current`} viewBox="0 0 92.8 92.8">
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="10"
      d="M46.4 5v82.8"
      data-name="Line 151"
    />
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="10"
      d="M87.8 46.4H5"
      data-name="Line 152"
    />
  </svg>
);

export const AddSquareIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24">
    <g data-name="Group 3533">
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        data-name="Group 335"
        transform="translate(1 1)"
      >
        <path d="M11 6v10" data-name="Line 26" />
        <path d="M16 11H6" data-name="Line 27" />
        <rect width="22" height="22" data-name="Rectangle 407" rx="5" />
      </g>
    </g>
  </svg>
);

export const AddUserIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.5 27.4" className={`stroke-current ${className}`}>
    <g data-name="Group 2743">
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M23.3 5.6h6.2"
        data-name="Line 30"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M26.4 8.7V2.5"
        data-name="Line 31"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M22 23.4V25a1.5 1.5 0 0 1-1.6 1.5H2.5A1.5 1.5 0 0 1 1 25v-1.5C1 19 6.2 16 11.5 16s10.4 3 10.4 7.5"
        data-name="Path 9566"
      />
      <g data-name="Group 2742" transform="translate(6.2 1)">
        <circle
          cx="5.2"
          cy="5.2"
          r="5.2"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          data-name="Ellipse 31"
        />
      </g>
    </g>
  </svg>
);

export const AdNetworkExchangeIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 47.4 45">
    <g fill="none" strokeLinecap="round" strokeWidth="2" data-name="Group 5639">
      <g data-name="Group 5638">
        <path d="M1.7 2.3a.6.6 0 1 1 0 0h0" data-name="Path 14139" />
        <path d="M9.4 1a8.1 8.1 0 0 1-8 8.4H1" data-name="Path 14140" />
        <path d="M1 17.7a18.4 18.4 0 0 0 6-1 15.8 15.8 0 0 0 9.7-9.8 18.3 18.3 0 0 0 1-5.9" data-name="Path 14141" />
        <path
          d="M22.5 38h0a5.8 5.8 0 0 0 5.8 6h12.2a5.9 5.9 0 0 0 5.8-6h0a5.8 5.8 0 0 0-5.8-5.8H28.3a5.8 5.8 0 0 0-5.8 5.9Z"
          data-name="Path 14142"
        />
        <path d="m46.3 37.6-.8-10.7a4.8 4.8 0 0 0-4.8-4.4H28.1a4.8 4.8 0 0 0-4.8 4.4l-.8 10.7" data-name="Path 14143" />
        <path d="M40.1 37.9a.1.1 0 0 1 .2 0 .1.1 0 0 1 0 .1.1.1 0 0 1-.2-.1" data-name="Path 14144" />
      </g>
      <g data-name="Rectangle 1209">
        <path d="M27.2 1H33a11 11 0 0 1 11 11h0v5M12 44A11 11 0 0 1 1 33h0v-5.8" data-name="Path 14088" />
        <path d="M16.7 44H12" data-name="Line 83" />
      </g>
    </g>
  </svg>
);

export const AnalyticsIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 40.5 28.3">
    <g data-name="Group 77">
      <g data-name="Group 76">
        <g data-name="Group 74">
          <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M1 27.3h38.5"
            data-name="Line 7"
          />
        </g>
        <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" data-name="Group 75">
          <path d="M6.1 27.3V18" data-name="Line 8" />
          <path d="M15.5 27.3V10.4" data-name="Line 9" />
          <path d="M25 27.3V1" data-name="Line 10" />
          <path d="M34.3 27.4V14.2" data-name="Line 11" />
        </g>
      </g>
    </g>
  </svg>
);

export const AudienceIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 46 46">
    <g fill="none" strokeWidth="2" data-name="Rectangle 1206">
      <rect width="46" height="46" stroke="none" rx="12" />
      <rect width="44" height="44" x="1" y="1" rx="11" />
    </g>
    <g data-name="Group 4989">
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        data-name="Group 4988"
        transform="translate(10.2 13.3)"
      >
        <circle cx="3.2" cy="3.2" r="3.2" data-name="Ellipse 140" transform="translate(9.5 7.6)" />
        <circle cx="3.2" cy="3.2" r="3.2" data-name="Ellipse 141" transform="translate(16.4)" />
        <path d="M20.2 10.1a8.3 8.3 0 0 1 5 1.7" data-name="Path 13457" />
        <circle cx="3.2" cy="3.2" r="3.2" data-name="Ellipse 142" transform="translate(2.5)" />
        <path d="M0 11.8A8.3 8.3 0 0 1 5 10" data-name="Path 13458" />
        <path d="M18.4 19.6a9.8 9.8 0 0 0-11.6 0" data-name="Path 13459" />
      </g>
    </g>
  </svg>
);

export const AudioIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 26.3 28">
    <g data-name="Group 5771">
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        data-name="Group 3362"
        transform="translate(.8 .8)"
      >
        <path d="M8 22.5V6.8a1.6 1.6 0 0 1 1-1.5L22.6 0a1.6 1.6 0 0 1 2.2 1.5v17.7" data-name="Path 11915" />
        <circle cx="4" cy="4" r="4" data-name="Ellipse 46" transform="translate(16.8 15.3)" />
        <circle cx="4" cy="4" r="4" data-name="Ellipse 47" transform="translate(0 18.5)" />
      </g>
    </g>
  </svg>
);

export const BannerIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 30.7 27">
    <g data-name="Group 5769">
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        data-name="Group 3412"
        transform="translate(.8 .8)"
      >
        <rect width="29.2" height="25.5" data-name="Rectangle 1031" rx="5" />
        <path d="M0 6.7h29.2" data-name="Line 41" />
        <path d="M4.5 3.5h0M8 3.5h0M11.7 3.5h0" data-name="Shape 3077" />
        <rect width="6.7" height="4.5" data-name="Rectangle 1032" rx="1" transform="translate(6.7 11.2)" />
        <path d="M18 11.2h5.2" data-name="Line 42" />
        <path d="M18 15.7h3.7" data-name="Line 43" />
        <path d="M23.2 24.6v-3.5a1.3 1.3 0 0 0-1.4-1.2H7.6a1.3 1.3 0 0 0-1.4 1.2v3.5" data-name="Path 11931" />
      </g>
    </g>
  </svg>
);

export const BasicsListIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 45 45">
    <g data-name="Group 5000">
      <g data-name="Group 4997">
        <g
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          data-name="Group 4999"
          transform="translate(1.5 -4.8)"
        >
          <path d="M23 34.3h11" data-name="Line 70" />
          <circle cx="3" cy="3" r="3" data-name="Ellipse 143" transform="translate(8.5 31)" />
          <path d="M23 21.3h11" data-name="Line 71" />
          <circle cx="3" cy="3" r="3" data-name="Ellipse 144" transform="translate(8.5 17.6)" />
        </g>
      </g>
      <g fill="none" strokeWidth="2" data-name="Rectangle 1209">
        <rect width="45" height="45" stroke="none" rx="12" />
        <rect width="43" height="43" x="1" y="1" rx="11" />
      </g>
    </g>
  </svg>
);

export const BudgetIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 36.7 36.7">
    <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" data-name="Group 5005">
      <path d="M3.1 10a17.4 17.4 0 0 1 32.6 8.4" data-name="Path 13462" />
      <path d="M18.4 13v-2.4" data-name="Path 13463" />
      <path d="M18.4 24v2" data-name="Path 13464" />
      <path
        d="M15.3 22.4a2.6 2.6 0 0 0 2.2 1.3h2a2.5 2.5 0 0 0 .5-5l-3.3-.7a2.5 2.5 0 0 1 .6-5h2a2.6 2.6 0 0 1 2.1 1.3"
        data-name="Path 13465"
      />
      <path d="M1 18.4a17.4 17.4 0 0 0 32.6 8.3" data-name="Path 13466" />
      <path d="M9.8 10H2V2.5" data-name="Path 13467" />
      <path d="M27 26.7h7.6v7.7" data-name="Path 13468" />
    </g>
  </svg>
);

export const BuildRocket = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" stroke="current" viewBox="0 0 32 32">
    <g data-name="Group 2773">
      <g strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" data-name="Group 2766">
        <path
          d="M24.5 16.2l-9 7.2a1.7 1.7 0 01-2.2-.1l-4.6-4.6a1.7 1.7 0 010-2.2l7.1-9A17.4 17.4 0 0129.4 1h0A1.7 1.7 0 0131 2.7h0a17.4 17.4 0 01-6.5 13.5z"
          data-name="Path 9574"
        />
        <path d="M22.7 17.7V25a1.7 1.7 0 01-1 1.5l-4 2a1.7 1.7 0 01-2.3-1l-1-3.1" data-name="Path 9575" />
        <path d="M7.7 17.7l-3.2-1a1.7 1.7 0 01-1-2.4l2-4a1.7 1.7 0 011.5-1h7.3" data-name="Path 9576" />
        <path
          d="M5.6 30.3L1 31l.7-4.6a3.4 3.4 0 012.9-2.8h0a3.4 3.4 0 013.9 3.9h0a3.4 3.4 0 01-3 2.8z"
          data-name="Path 9577"
        />
      </g>
    </g>
  </svg>
);

export const BulbIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={`stroke-current ${className}`} viewBox="0 0 44.6 38.4">
    <defs>
      <clipPath id="a">
        <path fill="none" strokeWidth="2" d="M0 0h44.6v38.4H0z" data-name="Rectangle 1859" />
      </clipPath>
    </defs>
    <g data-name="Group 7196">
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M28.2 25.6H16.5"
        data-name="Line 229"
      />
      <g data-name="Group 7197">
        <g
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          clipPath="url(#a)"
          data-name="Group 7196"
        >
          <path
            d="M15.6 25A11.7 11.7 0 1 1 29 25a2 2 0 0 0-1 1.7V32a4.9 4.9 0 0 1-4.8 4.9h-2a4.9 4.9 0 0 1-4.8-5v-5.3a2 2 0 0 0-1-1.7Z"
            data-name="Path 16743"
          />
          <path d="m38 5.7 2.2-2.3" data-name="Line 230" />
          <path d="m6.7 25.3-2.3 2.3" data-name="Line 231" />
          <path d="M8.6 3.8 6.3 1.5" data-name="Line 232" />
          <path d="m38 25.3 2.2 2.3" data-name="Line 233" />
          <path d="M39.9 15.5h3.3" data-name="Line 234" />
          <path d="M1.5 15.5h3.3" data-name="Line 235" />
          <path d="M16.5 31.1H28" data-name="Line 236" />
        </g>
      </g>
    </g>
  </svg>
);

export const CloseIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 16.4 16.4">
    <g fill="none" strokeLinecap="round" strokeWidth="2" data-name="Group 3372">
      <path d="M1.4 15 15 1.3" data-name="Path 9578" />
      <path d="M1.4 1.4 15 15" data-name="Path 9579" />
    </g>
  </svg>
);

export const CheckIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 19.824 14.071">
    <path
      id="shape"
      d="M508.212,1359.9l5.339,5.339,11.657-11.657"
      transform="translate(-506.798 -1352.166)"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
  </svg>
);

export const ChevronRight = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 7.3 15.8">
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M1.4 14.4 6.3 8 1.4 1.4"
      data-name="Path 13453"
    />
  </svg>
);

export const ChevronLeft = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 7.3 15.8">
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M5.9 1.4L1 7.9l4.9 6.5"
      data-name="Path 13013"
    />
  </svg>
);

export const CalendarIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 32 35">
    <g data-name="Group 5008">
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        data-name="Group 5007"
        transform="translate(1 1)"
      >
        <path d="M22 0v7" data-name="Line 72" />
        <path d="M8 0v7" data-name="Line 73" />
        <path d="M0 12h30" data-name="Line 74" />
        <rect width="30" height="29" data-name="Rectangle 1208" rx="2" transform="translate(0 4)" />
        <path
          d="M15 18.6a.4.4 0 1 0 .4.4.4.4 0 0 0-.4-.4M23.4 18.6a.4.4 0 1 0 .5.4.4.4 0 0 0-.5-.4M6.6 25.3a.4.4 0 1 0 .4.4.4.4 0 0 0-.4-.4M15 25.3a.4.4 0 1 0 .4.4.4.4 0 0 0-.4-.4"
          data-name="Shape 3077"
        />
      </g>
    </g>
  </svg>
);

export const ChevronDown = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 17 7.7">
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m1.4 1.4 7.1 5.3 7.1-5.3"
      data-name="Path 14087"
    />
  </svg>
);

export const ChevronUp = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" transform="scale(-1 -1)" className={className} viewBox="0 0 17 7.7">
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m1.4 1.4 7.1 5.3 7.1-5.3"
      data-name="Path 14087"
    />
  </svg>
);

export const ClicksIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 38 38">
    <g data-name="Group 4914">
      <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" data-name="Group 4913">
        <path d="m17 29.2-1.6 1.5" data-name="Line 62" />
        <path d="M23.1 12.4v2.2" data-name="Line 63" />
        <path d="M15.4 15.4 17 17" data-name="Line 64" />
        <path d="M12.4 23.1h2.2" data-name="Line 65" />
        <path d="M30.7 15.4 29.2 17" data-name="Line 66" />
        <path
          d="M8.6 33h-2A5.7 5.7 0 0 1 1 27.5V6.7A5.7 5.7 0 0 1 6.7 1h20.8a5.7 5.7 0 0 1 5.7 5.7v1.9"
          data-name="Path 13443"
        />
        <path
          d="M26.4 36.4 22 23a.8.8 0 0 1 1-1l13.5 4.5a.8.8 0 0 1 .1 1.5l-6 2.6-2.6 6a.8.8 0 0 1-1.5 0Z"
          data-name="Path 13444"
        />
      </g>
    </g>
  </svg>
);

export const CtvIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 29 27.3">
    <g data-name="Group 5766">
      <g data-name="Group 5473">
        <g data-name="Group 5472" transform="translate(.8 .8)">
          <rect
            width="27.5"
            height="19.7"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            data-name="Rectangle 1326"
            rx="1.1"
          />
        </g>
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M4.5 26.4a36 36 0 0 1 20 0"
          data-name="Path 13623"
        />
      </g>
      <g data-name="Group 5475">
        <g data-name="Group 3365">
          <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="m12.6 14.3 6.2-3.6-6.2-3.6Z"
            data-name="Path 11916"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const DevicesIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 28.1 28.1">
    <g data-name="Group 5782">
      <g data-name="Group 5508">
        <g data-name="Group 5507">
          <g data-name="Group 5506">
            <path
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M27.4 8.1h0A7.4 7.4 0 0 0 20 .7H8A7.4 7.4 0 0 0 .7 8.1V20a7.4 7.4 0 0 0 7.4 7.4H13"
              data-name="Path 14057"
            />
          </g>
        </g>
      </g>
      <g data-name="Group 5521" transform="translate(7.5 8.3)">
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14.8 5.5V1.6h0A1.6 1.6 0 0 0 13 0H1.6A1.6 1.6 0 0 0 0 1.6V9h0a1.6 1.6 0 0 0 1.6 1.7H10"
          data-name="Path 14064"
        />
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.7 13.7h-5"
          data-name="Line 79"
        />
        <g data-name="Group 5520">
          <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M15.8 15.8h-2"
            data-name="Path 14065"
          />
        </g>
        <rect
          width="9.2"
          height="12.8"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          data-name="Rectangle 1333"
          rx="1.2"
          transform="translate(10.2 5.6)"
        />
      </g>
    </g>
  </svg>
);

export const DotsIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={`${className} fill-current`} viewBox="0 0 7 37">
    <circle cx="3.5" cy="3.5" r="3.5" data-name="Ellipse 190" />
    <circle cx="3.5" cy="3.5" r="3.5" data-name="Ellipse 191" transform="translate(0 15)" />
    <circle cx="3.5" cy="3.5" r="3.5" data-name="Ellipse 192" transform="translate(0 30)" />
  </svg>
);

export const DownloadIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 29.7 29.9">
    <g data-name="Group 5616">
      <g data-name="Group 5613">
        <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" data-name="Group 5579">
          <path d="M14.8 1v22" data-name="Line 88" />
          <path d="m10.2 18.4 4.6 4.6 4.7-4.6" data-name="Path 14101" />
          <path
            d="M8.7 12H4A3 3 0 0 0 1 15v10.8A3 3 0 0 0 4 29h21.6a3 3 0 0 0 3-3V15a3 3 0 0 0-3-3.1H21"
            data-name="Path 14102"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const EditIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 30.9 31.1">
    <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" data-name="Group 2777">
      <path d="M26.2 9.3L21.8 5" data-name="Line 7" />
      <path d="M29.4 14.1v1.6a14 14 0 01-14 14h0a14 14 0 01-13.9-14h0a14 14 0 0114-14H17" data-name="Path 47" />
      <path
        stroke="#03012b"
        d="M29 4.3l-2.2-2.2a1.6 1.6 0 00-2.2 0L10.4 16.4v4.4h4.4L29 6.5a1.6 1.6 0 000-2.2z"
        data-name="Path 48"
      />
    </g>
  </svg>
);

export const Email = ({ stroke = 'none', className }) => (
  <svg viewBox="0 0 44 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M7.37476 8.5L21.8748 18L36.3748 8.5"
      stroke={stroke}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7.62524 22L14.6252 14" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" />
    <path d="M35.9169 21.5192L28.6252 14" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" />
    <rect x="2" y="2" width="40" height="28" rx="4" stroke={stroke} strokeWidth="2.5" />
  </svg>
);

export const ForecastCloud = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 32.4 34.1">
    <g data-name="Group 73">
      <g data-name="Group 40">
        <g data-name="Group 39">
          <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M10.1 21.8a5.3 5.3 0 012.4.6 7.4 7.4 0 0114.6 1 5 5 0 01-.6 9.7H10.1a5.6 5.6 0 010-11.3z"
            data-name="Path 45"
          />
        </g>
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M14.5 2.3V1"
          data-name="Line 3"
        />
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M23 6l1-1"
          data-name="Line 4"
        />
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M1 14.5h1.3"
          data-name="Line 5"
        />
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 5l1 1"
          data-name="Line 6"
        />
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M19.2 9.7a6.7 6.7 0 00-11.5 4.8"
          data-name="Path 46"
        />
      </g>
    </g>
  </svg>
);

export const ForecastCloudLg = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 344.5 340">
    <g data-name="Group 5729">
      <g data-name="Group 5725">
        <g data-name="Group 5724">
          <path
            fill="#f5f5f5"
            stroke="none"
            d="M55.4 206.3a51.9 51.9 0 0 1 23.6 5.3 72.5 72.5 0 0 1 71.5-61.4 72.8 72.8 0 0 1 72.6 71 48.4 48.4 0 0 1-6.3 96.3H55.4a55.6 55.6 0 0 1 0-111.2Z"
            data-name="Path 14982"
          />
        </g>
      </g>
      <g data-name="Group 5728">
        <g data-name="Group 5727">
          <g data-name="Group 5726">
            <path
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="10"
              d="M113.6 223.8a59.6 59.6 0 0 1 25.5 5.3c5.6-34.7 38.1-61.4 77-61.4 42.5 0 77.2 31.7 78.3 71a49.5 49.5 0 0 1 45.1 48c0 26.7-23.2 48.3-52 48.3H113.7c-33 0-59.7-25-59.7-55.6s26.7-55.6 59.7-55.6Z"
              data-name="Path 14983"
            />
          </g>
          <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="10"
            d="M161.2 18.2V5"
            data-name="Line 99"
          />
          <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="10"
            d="m251.8 53.2 9.4-9.4"
            data-name="Line 100"
          />
          <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="10"
            d="M19.5 143.2h13.2"
            data-name="Line 101"
          />
          <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="10"
            d="m58.3 43.8 9.4 9.4"
            data-name="Line 102"
          />
          <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="10"
            d="M206.3 94.3a66.2 66.2 0 0 0-113.1 46.8"
            data-name="Path 14984"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const ReportIconLg = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 303.928 327.219">
    <g stroke="#f5f5f5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="10" data-name="Group 6468">
      <path
        fill="#f5f5f5"
        d="M234.855 223.709V105.958a32.864 32.864 0 0 0-9.624-23.217l-46.43-46.434a32.851 32.851 0 0 0-23.214-9.616H37.835A32.831 32.831 0 0 0 5 59.527v229.855a32.832 32.832 0 0 0 32.835 32.841h197.02Z"
        data-name="Path 39"
      />
      <path fill="none" d="M54.254 158.039h98.51" data-name="Path 41" />
      <path fill="none" d="M54.254 207.291h98.51" data-name="Path 42" />
      <path fill="none" d="M54.254 256.544h71.093" data-name="Path 43" />
      <path fill="none" d="M234.856 108.789h-65.674a16.424 16.424 0 0 1-16.417-16.424V26.691" data-name="Path 44" />
    </g>
    <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="10" data-name="Group 32">
      <path
        d="M264.02 202.018V84.267a32.864 32.864 0 0 0-9.624-23.217l-46.43-46.434A32.851 32.851 0 0 0 184.752 5H67a32.831 32.831 0 0 0-32.835 32.836v229.855A32.832 32.832 0 0 0 67 300.532h98.51"
        data-name="Path 39"
      />
      <path d="m296.856 251.275-49.254 49.257-32.836-32.837" data-name="Path 40" />
      <path d="M83.419 136.348h98.51" data-name="Path 41" />
      <path d="M83.419 185.6h98.51" data-name="Path 42" />
      <path d="M83.419 234.853h71.093" data-name="Path 43" />
      <path d="M264.021 87.098h-65.674a16.424 16.424 0 0 1-16.417-16.424V5" data-name="Path 44" />
    </g>
  </svg>
);

export const GeoIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 28.1 29.6">
    <g data-name="Group 5784">
      <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" data-name="Group 5017">
        <path
          d="M12.6 2.2H8A7.4 7.4 0 0 0 .8 9.6v11.8A7.4 7.4 0 0 0 8 28.8H20a7.4 7.4 0 0 0 7.3-7.4v-5.9"
          data-name="Path 13469"
        />
        <g data-name="Group 5016">
          <path d="M22.2 5.6a.4.4 0 1 1-.4.3.4.4 0 0 1 .4-.3" data-name="Path 13470" />
          <path
            d="M27.3 6h0A5.2 5.2 0 0 0 22.2.6h0A5.2 5.2 0 0 0 17 6h0c0 2.4 2.6 5 4.2 6.3a1.6 1.6 0 0 0 2 0c1.5-1.3 4.1-3.9 4.1-6.3Z"
            data-name="Path 13471"
          />
        </g>
        <path d="m2.4 5.4 22 22" data-name="Line 75" />
        <path d="m2.4 25.8 10-10.5" data-name="Line 76" />
      </g>
    </g>
  </svg>
);

export const GoalIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 34.2 32.3">
    <g data-name="Group 4912">
      <g data-name="Group 4911">
        <g data-name="Group 4910">
          <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M28.5 29.3 3.5 21A3.6 3.6 0 0 1 1 17.6v-4.7a3.6 3.6 0 0 1 2.4-3.4l25-8.3a3.6 3.6 0 0 1 4.8 3.4v21.3a3.6 3.6 0 0 1-4.7 3.4Z"
            data-name="Path 13440"
          />
        </g>
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M10.1 23.2a5.7 5.7 0 1 0 10.7 3.5"
          data-name="Path 13441"
        />
      </g>
    </g>
  </svg>
);

export const InventoryIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 27.8 28.5">
    <g data-name="Group 5783">
      <g data-name="Group 5507">
        <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" data-name="Group 5506">
          <path
            d="M9.3 26.3H7.9a7.1 7.1 0 0 1-7.2-7V7.8A7.1 7.1 0 0 1 8 .7h11.3A7.1 7.1 0 0 1 26.3 8v2.8"
            data-name="Path 14057"
          />
          <path d="m6.4 8.6 1.2 1L10 7.5" data-name="Path 14058" />
          <path d="M15 9.3h5.7" data-name="Path 14059" />
          <path d="m6.4 15.7 1.2 1 2.4-2" data-name="Path 14060" />
          <g data-name="Group 5505">
            <path
              d="M25.6 27.8H16a1.6 1.6 0 0 1-1.6-1.6v-7a4.3 4.3 0 0 1 .3-1.7l.6-1.5a1.8 1.8 0 0 1 1.6-1h7.6a1.8 1.8 0 0 1 1.7 1l.6 1.5a4.3 4.3 0 0 1 .3 1.7v7.1a1.4 1.4 0 0 1-1.4 1.5Z"
              data-name="Path 14061"
            />
            <path d="M20.7 15v4.8" data-name="Path 14062" />
            <path d="M27 26.2v-5a1.4 1.4 0 0 0-1.4-1.4h-10a1.4 1.4 0 0 0-1.3 1.4v5" data-name="Path 14063" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Logo = ({ className, fillClass = 'fill-primary' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} id="Layer_1" viewBox="0 0 397.46 69.24">
    <defs />
    <path
      className={fillClass}
      fill="#ff5390"
      d="m60.79 42.2-1.08.69c.95 1.87 1.53 4.17 1.53 6.21 0 5.86-5.12 12.39-12.46 12.39H19.91c-2.79 0-5.88-1.43-8.27-3.82-2.48-2.48-3.9-5.64-3.9-8.68V19.8c0-2.51 1.53-5.59 3.98-8.04 2.51-2.51 5.57-4.01 8.18-4.01h28.98c2.82 0 5.86 1.44 8.32 3.96 2.41 2.46 3.85 5.57 3.85 8.31 0 6.92-4.45 9.7-4.92 9.97l-7.79 4.43C40.08 39.13 30 44.89 27.09 46.51c-.39.22-1.04.05-1.04-.5s-.12-22.61-.12-23.07.61-.72.98-.52l16.17 9.05 7.87-4.49c-9.34-5.34-21.39-11.94-22.56-12.58-1.03-.6-2.2-.92-3.41-.92-3.76 0-6.81 2.98-6.81 6.65l.15 28.81v.04c.06 3.78 2.82 6.52 6.57 6.52 1.05 0 2.1-.22 3.13-.65l.19-.08.18-.1c.16-.09 16.79-9.4 27.75-15.6l6.79-4.45.98-.93c3.98-4.47 4.88-9.8 4.88-13.67 0-4.79-2.21-9.79-6.05-13.73-3.91-4-8.96-6.3-13.86-6.3H19.91c-4.69.01-9.67 2.3-13.66 6.29C2.28 10.25 0 15.18 0 19.8V49c0 5.08 2.25 10.24 6.17 14.16 3.87 3.87 8.88 6.08 13.74 6.08h28.87c5.41 0 10.52-2.2 14.39-6.2 3.7-3.81 5.82-8.89 5.82-13.94 0-2.78-.47-6.7-2.77-10.49l-5.43 3.58Z"
    />
    <path
      d="M124.22 38.26c1.28 1.62 1.92 3.68 1.92 6.16 0 3.32-1.25 5.88-3.75 7.66-2.5 1.79-6.14 2.68-10.92 2.68H93.18V16.45h17.19c4.38 0 7.76.88 10.16 2.63 2.39 1.75 3.59 4.18 3.59 7.28 0 2.01-.47 3.74-1.4 5.2s-2.18 2.57-3.75 3.34c2.23.62 3.98 1.74 5.26 3.37ZM98.65 20.88v12.26h11.22c2.81 0 4.97-.52 6.49-1.56 1.52-1.04 2.27-2.56 2.27-4.57s-.76-3.53-2.27-4.57c-1.51-1.04-3.68-1.56-6.49-1.56H98.65Zm19.6 27.92c1.57-1.02 2.35-2.63 2.35-4.82 0-4.27-3.12-6.41-9.36-6.41H98.65v12.76h12.59c3.1 0 5.44-.51 7.01-1.53ZM139.66 26.79c1.79-.88 3.96-1.31 6.51-1.31v5.09c-.29-.04-.69-.05-1.2-.05-2.85 0-5.08.85-6.71 2.55-1.62 1.7-2.44 4.12-2.44 7.25v14.45h-5.26V25.75h5.04v4.87c.91-1.68 2.26-2.96 4.05-3.83ZM171.27 28.43c2.14 1.97 3.2 4.91 3.2 8.82v17.52h-4.98v-3.83c-.88 1.35-2.13 2.38-3.75 3.09s-3.55 1.07-5.78 1.07c-3.25 0-5.85-.78-7.8-2.35-1.95-1.57-2.93-3.63-2.93-6.19s.93-4.61 2.79-6.16 4.82-2.33 8.87-2.33h8.32v-1.04c0-2.26-.66-4-1.97-5.2-1.31-1.2-3.25-1.81-5.8-1.81-1.72 0-3.39.28-5.04.85-1.64.57-3.03 1.32-4.16 2.27l-2.19-3.94c1.5-1.2 3.29-2.13 5.37-2.77 2.08-.64 4.29-.96 6.62-.96 4.01 0 7.09.99 9.23 2.96Zm-5.23 21.27c1.46-.89 2.52-2.16 3.17-3.8v-4.05h-8.1c-4.45 0-6.68 1.5-6.68 4.49 0 1.46.57 2.61 1.7 3.45 1.13.84 2.7 1.26 4.71 1.26s3.74-.45 5.2-1.34ZM204.12 28.68c2.17 2.13 3.26 5.26 3.26 9.39v16.7h-5.26v-16.1c0-2.81-.68-4.93-2.03-6.35-1.35-1.42-3.29-2.13-5.8-2.13-2.85 0-5.09.83-6.73 2.49-1.64 1.66-2.46 4.04-2.46 7.14v14.95h-5.26V25.75h5.04v4.38c1.06-1.5 2.49-2.65 4.3-3.45 1.81-.8 3.86-1.2 6.16-1.2 3.69 0 6.61 1.07 8.79 3.2ZM241.38 14.15v40.62h-5.04v-4.6a11.416 11.416 0 0 1-4.43 3.67c-1.79.84-3.76 1.26-5.91 1.26-2.81 0-5.33-.62-7.55-1.86-2.23-1.24-3.97-2.98-5.23-5.23-1.26-2.24-1.89-4.83-1.89-7.75s.63-5.49 1.89-7.72c1.26-2.23 3-3.96 5.23-5.2 2.23-1.24 4.74-1.86 7.55-1.86 2.08 0 4 .39 5.75 1.18 1.75.78 3.21 1.94 4.38 3.48V14.15h5.26Zm-9.96 35.07c1.5-.86 2.66-2.06 3.5-3.61.84-1.55 1.26-3.33 1.26-5.34s-.42-3.79-1.26-5.34c-.84-1.55-2.01-2.75-3.5-3.59-1.5-.84-3.16-1.26-4.98-1.26s-3.53.42-5.01 1.26c-1.48.84-2.65 2.04-3.5 3.59-.86 1.55-1.29 3.33-1.29 5.34s.43 3.79 1.29 5.34c.86 1.55 2.02 2.76 3.5 3.61 1.48.86 3.15 1.29 5.01 1.29s3.48-.43 4.98-1.29ZM271.76 50.44v4.33h-24.31v-3.39l17.14-21.3h-16.81v-4.33h23.54v3.45l-17.14 21.24h17.57ZM281.89 53.18c-2.3-1.28-4.1-3.04-5.39-5.28s-1.94-4.79-1.94-7.64.65-5.39 1.94-7.64c1.29-2.24 3.09-4 5.39-5.26 2.3-1.26 4.89-1.89 7.78-1.89s5.46.63 7.75 1.89c2.28 1.26 4.07 3.01 5.37 5.26 1.29 2.24 1.94 4.79 1.94 7.64s-.65 5.39-1.94 7.64a13.835 13.835 0 0 1-5.37 5.28c-2.28 1.28-4.86 1.92-7.75 1.92s-5.47-.64-7.78-1.92Zm12.78-3.97c1.48-.86 2.64-2.06 3.48-3.61.84-1.55 1.26-3.33 1.26-5.34s-.42-3.79-1.26-5.34c-.84-1.55-2-2.75-3.48-3.59-1.48-.84-3.15-1.26-5.01-1.26s-3.53.42-5.01 1.26c-1.48.84-2.65 2.04-3.5 3.59-.86 1.55-1.29 3.33-1.29 5.34s.43 3.79 1.29 5.34c.86 1.55 2.02 2.76 3.5 3.61 1.48.86 3.15 1.29 5.01 1.29s3.53-.43 5.01-1.29ZM315.56 53.18c-2.3-1.28-4.1-3.04-5.39-5.28s-1.94-4.79-1.94-7.64.65-5.39 1.94-7.64c1.29-2.24 3.09-4 5.39-5.26 2.3-1.26 4.89-1.89 7.78-1.89s5.46.63 7.75 1.89c2.28 1.26 4.07 3.01 5.37 5.26 1.29 2.24 1.94 4.79 1.94 7.64s-.65 5.39-1.94 7.64a13.835 13.835 0 0 1-5.37 5.28c-2.28 1.28-4.86 1.92-7.75 1.92s-5.47-.64-7.78-1.92Zm12.78-3.97c1.48-.86 2.64-2.06 3.48-3.61.84-1.55 1.26-3.33 1.26-5.34s-.42-3.79-1.26-5.34c-.84-1.55-2-2.75-3.48-3.59-1.48-.84-3.15-1.26-5.01-1.26s-3.53.42-5.01 1.26c-1.48.84-2.65 2.04-3.5 3.59-.86 1.55-1.29 3.33-1.29 5.34s.43 3.79 1.29 5.34c.86 1.55 2.02 2.76 3.5 3.61 1.48.86 3.15 1.29 5.01 1.29s3.53-.43 5.01-1.29ZM353.67 41.25l-6.02 5.58v7.94h-5.26V14.15h5.26v26.06l15.82-14.45h6.35l-12.21 11.99 13.41 17.03h-6.46l-10.9-13.52ZM394.26 28.43c2.14 1.97 3.2 4.91 3.2 8.82v17.52h-4.98v-3.83c-.88 1.35-2.13 2.38-3.75 3.09s-3.55 1.07-5.78 1.07c-3.25 0-5.85-.78-7.8-2.35-1.95-1.57-2.93-3.63-2.93-6.19s.93-4.61 2.79-6.16 4.82-2.33 8.87-2.33h8.32v-1.04c0-2.26-.66-4-1.97-5.2-1.31-1.2-3.25-1.81-5.8-1.81-1.72 0-3.39.28-5.04.85-1.64.57-3.03 1.32-4.16 2.27l-2.19-3.94c1.5-1.2 3.29-2.13 5.37-2.77 2.08-.64 4.29-.96 6.62-.96 4.01 0 7.09.99 9.23 2.96Zm-5.23 21.27c1.46-.89 2.52-2.16 3.17-3.8v-4.05h-8.1c-4.45 0-6.68 1.5-6.68 4.49 0 1.46.57 2.61 1.7 3.45 1.13.84 2.7 1.26 4.71 1.26s3.74-.45 5.2-1.34Z"
      className="cls-1"
    />
  </svg>
);

export const LogoPlus = ({ className, fillClass }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    xmlSpace="preserve"
    id="Layer_1"
    x="0"
    y="0"
    version="1.1"
    viewBox="0 0 453.4 69.2"
  >
    <path
      className={fillClass}
      fill="#ff5390"
      d="m60.8 42.2-1.1.7c.9 1.9 1.5 4.2 1.5 6.2 0 5.9-5.1 12.4-12.5 12.4H19.9c-2.8 0-5.9-1.4-8.3-3.8C9.2 55.2 7.7 52 7.7 49V19.8c0-2.5 1.5-5.6 4-8 2.5-2.5 5.6-4 8.2-4h29c2.8 0 5.9 1.4 8.3 4 2.4 2.5 3.8 5.6 3.8 8.3 0 6.9-4.5 9.7-4.9 10l-7.8 4.4c-8.2 4.6-18.3 10.4-21.2 12-.4.2-1 0-1-.5S26 23.4 26 22.9s.6-.7 1-.5l16.2 9L51 27c-9.3-5.3-21.4-11.9-22.6-12.6-1-.6-2.2-.9-3.4-.9-3.8 0-6.8 3-6.8 6.6l.1 28.8c.1 3.8 2.8 6.5 6.6 6.5 1.1 0 2.1-.2 3.1-.7l.2-.1.2-.1c.2-.1 16.8-9.4 27.8-15.6l6.8-4.5 1-.9c4-4.5 4.9-9.8 4.9-13.7 0-4.8-2.2-9.8-6.1-13.7-3.9-4-9-6.3-13.9-6.3h-29c-4.7 0-9.7 2.3-13.7 6.3S0 15 0 19.6V49c0 5.1 2.2 10.2 6.2 14.2 3.8 3.8 8.8 6 13.7 6h28.9c5.4 0 10.5-2.2 14.4-6.2 3.7-3.8 5.8-8.9 5.8-13.9 0-2.8-.5-6.7-2.8-10.5l-5.4 3.6z"
    />
    <path
      d="M124.2 38.3c1.3 1.6 1.9 3.7 1.9 6.2 0 3.3-1.3 5.9-3.8 7.7-2.5 1.8-6.1 2.7-10.9 2.7H93.2V16.4h17.2c4.4 0 7.8.9 10.2 2.6 2.4 1.8 3.6 4.2 3.6 7.3 0 2-.5 3.7-1.4 5.2-.9 1.5-2.2 2.6-3.8 3.3 2.2.7 3.9 1.8 5.2 3.5zM98.6 20.9v12.3h11.2c2.8 0 5-.5 6.5-1.6 1.5-1 2.3-2.6 2.3-4.6 0-2-.8-3.5-2.3-4.6-1.5-1-3.7-1.6-6.5-1.6H98.6zm19.7 27.9c1.6-1 2.4-2.6 2.4-4.8 0-4.3-3.1-6.4-9.4-6.4H98.6v12.8h12.6c3.1-.1 5.5-.6 7.1-1.6zM139.7 26.8c1.8-.9 4-1.3 6.5-1.3v5.1c-.3 0-.7-.1-1.2-.1-2.8 0-5.1.8-6.7 2.5-1.6 1.7-2.4 4.1-2.4 7.3v14.5h-5.3v-29h5v4.9c.9-1.8 2.3-3 4.1-3.9zM171.3 28.4c2.1 2 3.2 4.9 3.2 8.8v17.5h-5v-3.8c-.9 1.4-2.1 2.4-3.8 3.1s-3.5 1.1-5.8 1.1c-3.2 0-5.8-.8-7.8-2.4-2-1.6-2.9-3.6-2.9-6.2s.9-4.6 2.8-6.2 4.8-2.3 8.9-2.3h8.3v-1c0-2.3-.7-4-2-5.2-1.3-1.2-3.2-1.8-5.8-1.8-1.7 0-3.4.3-5 .8-1.6.6-3 1.3-4.2 2.3l-2.2-3.9c1.5-1.2 3.3-2.1 5.4-2.8 2.1-.6 4.3-1 6.6-1 4.1.1 7.1 1.1 9.3 3zM166 49.7c1.5-.9 2.5-2.2 3.2-3.8v-4.1h-8.1c-4.5 0-6.7 1.5-6.7 4.5 0 1.5.6 2.6 1.7 3.4 1.1.8 2.7 1.3 4.7 1.3s3.8-.4 5.2-1.3zM204.1 28.7c2.2 2.1 3.3 5.3 3.3 9.4v16.7h-5.3V38.7c0-2.8-.7-4.9-2-6.4s-3.3-2.1-5.8-2.1c-2.8 0-5.1.8-6.7 2.5-1.6 1.7-2.5 4-2.5 7.1v14.9h-5.3v-29h5v4.4c1.1-1.5 2.5-2.6 4.3-3.4 1.8-.8 3.9-1.2 6.2-1.2 3.7 0 6.6 1 8.8 3.2zM241.4 14.1v40.6h-5v-4.6c-1.2 1.6-2.6 2.8-4.4 3.7-1.8.8-3.8 1.3-5.9 1.3-2.8 0-5.3-.6-7.6-1.9-2.2-1.2-4-3-5.2-5.2-1.3-2.2-1.9-4.8-1.9-7.7 0-2.9.6-5.5 1.9-7.7 1.3-2.2 3-4 5.2-5.2 2.2-1.2 4.7-1.9 7.6-1.9 2.1 0 4 .4 5.7 1.2 1.8.8 3.2 1.9 4.4 3.5v-16h5.2zm-10 35.1c1.5-.9 2.7-2.1 3.5-3.6.8-1.6 1.3-3.3 1.3-5.3s-.4-3.8-1.3-5.3c-.8-1.6-2-2.7-3.5-3.6-1.5-.8-3.2-1.3-5-1.3-1.9 0-3.5.4-5 1.3-1.5.8-2.6 2-3.5 3.6-.9 1.6-1.3 3.3-1.3 5.3s.4 3.8 1.3 5.3c.9 1.6 2 2.8 3.5 3.6 1.5.9 3.1 1.3 5 1.3s3.5-.4 5-1.3zM271.8 50.4v4.3h-24.3v-3.4L264.6 30h-16.8v-4.3h23.5v3.4l-17.1 21.2h17.6zM281.9 53.2c-2.3-1.3-4.1-3-5.4-5.3-1.3-2.2-1.9-4.8-1.9-7.6s.6-5.4 1.9-7.6c1.3-2.2 3.1-4 5.4-5.3 2.3-1.3 4.9-1.9 7.8-1.9s5.5.6 7.7 1.9c2.3 1.3 4.1 3 5.4 5.3 1.3 2.2 1.9 4.8 1.9 7.6s-.6 5.4-1.9 7.6c-1.3 2.2-3.1 4-5.4 5.3-2.3 1.3-4.9 1.9-7.7 1.9s-5.5-.6-7.8-1.9zm12.8-4c1.5-.9 2.6-2.1 3.5-3.6.8-1.6 1.3-3.3 1.3-5.3s-.4-3.8-1.3-5.3c-.8-1.6-2-2.7-3.5-3.6-1.5-.8-3.1-1.3-5-1.3s-3.5.4-5 1.3c-1.5.8-2.6 2-3.5 3.6-.9 1.6-1.3 3.3-1.3 5.3s.4 3.8 1.3 5.3c.9 1.6 2 2.8 3.5 3.6 1.5.9 3.1 1.3 5 1.3s3.5-.4 5-1.3zM315.6 53.2c-2.3-1.3-4.1-3-5.4-5.3-1.3-2.2-1.9-4.8-1.9-7.6s.6-5.4 1.9-7.6c1.3-2.2 3.1-4 5.4-5.3 2.3-1.3 4.9-1.9 7.8-1.9 2.9 0 5.5.6 7.7 1.9 2.3 1.3 4.1 3 5.4 5.3 1.3 2.2 1.9 4.8 1.9 7.6s-.6 5.4-1.9 7.6c-1.3 2.2-3.1 4-5.4 5.3-2.3 1.3-4.9 1.9-7.7 1.9-2.9 0-5.5-.6-7.8-1.9zm12.7-4c1.5-.9 2.6-2.1 3.5-3.6.8-1.6 1.3-3.3 1.3-5.3s-.4-3.8-1.3-5.3c-.8-1.6-2-2.7-3.5-3.6-1.5-.8-3.1-1.3-5-1.3s-3.5.4-5 1.3c-1.5.8-2.6 2-3.5 3.6-.9 1.6-1.3 3.3-1.3 5.3s.4 3.8 1.3 5.3c.9 1.6 2 2.8 3.5 3.6 1.5.9 3.1 1.3 5 1.3s3.6-.4 5-1.3zM353.7 41.2l-6 5.6v7.9h-5.3V14.1h5.3v26.1l15.8-14.5h6.3l-12.2 12 13.4 17h-6.5l-10.8-13.5zM394.3 28.4c2.1 2 3.2 4.9 3.2 8.8v17.5h-5v-3.8c-.9 1.4-2.1 2.4-3.8 3.1-1.6.7-3.5 1.1-5.8 1.1-3.2 0-5.8-.8-7.8-2.4-2-1.6-2.9-3.6-2.9-6.2s.9-4.6 2.8-6.2c1.9-1.6 4.8-2.3 8.9-2.3h8.3v-1c0-2.3-.7-4-2-5.2-1.3-1.2-3.2-1.8-5.8-1.8-1.7 0-3.4.3-5 .8-1.6.6-3 1.3-4.2 2.3l-2.2-3.9c1.5-1.2 3.3-2.1 5.4-2.8 2.1-.6 4.3-1 6.6-1 4.1.1 7.1 1.1 9.3 3zM389 49.7c1.5-.9 2.5-2.2 3.2-3.8v-4.1h-8.1c-4.5 0-6.7 1.5-6.7 4.5 0 1.5.6 2.6 1.7 3.4 1.1.8 2.7 1.3 4.7 1.3s3.8-.4 5.2-1.3z"
      className="st1"
    />
    <path
      d="M450.5 31.8h-14.8V17c0-1.6-1.3-2.9-2.9-2.9-1.6 0-2.9 1.3-2.9 2.9v14.8h-14.8c-1.6 0-2.9 1.3-2.9 2.9 0 1.6 1.3 2.9 2.9 2.9h14.8v14.8c0 1.6 1.3 2.9 2.9 2.9 1.6 0 2.9-1.3 2.9-2.9V37.5h14.8c1.6 0 2.9-1.3 2.9-2.9 0-1.6-1.3-2.8-2.9-2.8z"
      className={fillClass}
      fill="#ff5390"
    />
  </svg>
);

export const LogoPlusSign = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 18.9 18.9">
    <path
      d="M1428.4 5386.7h-6v-6a1.7 1.7 0 00-1.7-1.7 1.7 1.7 0 00-1.7 1.7v6h-6a1.7 1.7 0 00-1.8 1.7 1.7 1.7 0 001.8 1.7h6v6a1.7 1.7 0 001.7 1.8 1.7 1.7 0 001.7-1.7v-6h6a1.7 1.7 0 001.8-1.8 1.7 1.7 0 00-1.8-1.7z"
      data-name="Path 10178"
      transform="translate(-1411.2 -5379)"
    />
  </svg>
);

export const NotificationsIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 37.8 29.5">
    <g data-name="Group 4753" transform="translate(-1614.7 -34.8)">
      <g data-name="Group 250">
        <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" data-name="Group 23">
          <path d="M1623.3 59.2v.6a3.5 3.5 0 003.5 3.5h0a3.5 3.5 0 003.5-3.5v-.6" data-name="Path 32" />
          <path d="M1629.6 40v-1.4a2.8 2.8 0 00-2.8-2.8h0a2.8 2.8 0 00-2.8 2.8V40" data-name="Path 33" />
          <path
            d="M1618.5 46.8h0a7 7 0 017-7h2.7a7 7 0 016.9 7h0V51a3 3 0 00.9 2.2l1 1a3 3 0 01.9 2.1h0a2.9 2.9 0 01-3 3h-16.3a2.9 2.9 0 01-2.9-3h0a3 3 0 011-2.1l.9-1a3 3 0 00.9-2.2z"
            data-name="Path 34"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const PerformanceIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 50.4 53.1">
    <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" data-name="Group 5620">
      <g data-name="Group 5619">
        <path d="M33.3 1v5.4" data-name="Path 14112" />
        <path d="M11.8 1v5.4" data-name="Path 14113" />
        <path d="M1 17.1h43" data-name="Path 14114" />
        <path d="M44 25.2V11.8a8 8 0 0 0-8-8.1H9a8 8 0 0 0-8 8v21.6a8 8 0 0 0 8 8h8.1" data-name="Path 14115" />
        <path
          d="M25.2 37.6v9.7A4.8 4.8 0 0 0 30 52h14.6a4.8 4.8 0 0 0 4.8-4.8v-9.7a4.8 4.8 0 0 0-4.8-4.9H30a4.8 4.8 0 0 0-4.8 4.9Z"
          data-name="Path 14116"
        />
        <path d="M49.4 40.8H25.2" data-name="Path 14117" />
      </g>
      <path d="m10.2 32.5 5-5.3 2.5 3.2L23 25" data-name="Path 15247" />
    </g>
  </svg>
);

export const ReportingIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 32.1 35.4">
    <g data-name="Group 339">
      <g data-name="Group 72">
        <g strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" data-name="Group 32">
          <path
            d="M27 23.2V10a3.7 3.7 0 00-1.1-2.6l-5.3-5.2A3.7 3.7 0 0018 1H4.7A3.7 3.7 0 001 4.7v26a3.7 3.7 0 003.7 3.7h11.1"
            data-name="Path 39"
          />
          <path d="M30.7 28.8L25 34.4l-3.7-3.7" data-name="Path 40" />
          <path d="M6.6 15.8h11" data-name="Path 41" />
          <path d="M6.6 21.4h11" data-name="Path 42" />
          <path d="M6.6 27h8" data-name="Path 43" />
          <path d="M27 10.3h-7.5a1.9 1.9 0 01-1.8-1.9V1" data-name="Path 44" />
        </g>
      </g>
    </g>
  </svg>
);

export const SearchIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 17.5 17.3">
    <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" transform="translate(1 1)">
      <ellipse cx="6.8" cy="6.7" data-name="Ellipse 6" rx="6.8" ry="6.7" />
      <path d="M15 15l-3.4-3.6" data-name="Line 9" />
    </g>
  </svg>
);

export const SubtractIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={`${className} stroke-current`} viewBox="0 0 92.8 92.8">
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="10"
      d="M87.8 46.4H5"
      data-name="Line 152"
    />
  </svg>
);

export const ThreeDots = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 4.55 24.049">
    <g fill="var(--primary)" data-name="Group 13047" transform="translate(-28 -26.451)">
      <circle cx="2.275" cy="2.275" r="2.275" data-name="Ellipse 284" transform="translate(28 26.451)" />
      <circle cx="2.275" cy="2.275" r="2.275" data-name="Ellipse 285" transform="translate(28 36.201)" />
      <circle cx="2.275" cy="2.275" r="2.275" data-name="Ellipse 286" transform="translate(28 45.95)" />
    </g>
  </svg>
);

export const TopSitesIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 45.1 48.4">
    <g data-name="Group 5607">
      <g fill="none" strokeLinecap="round" strokeWidth="2" data-name="Rectangle 1209">
        <path d="M12 47.4a11 11 0 0 1-11-11v-21a11 11 0 0 1 11-11h21a11 11 0 0 1 11 11V23" data-name="Path 14088" />
        <path d="M16.7 47.4H12" data-name="Line 83" />
      </g>
      <g data-name="Group 5576">
        <g fill="none" strokeLinecap="round" strokeWidth="2" data-name="Group 5575">
          <path d="M10.6 21.6h9.6" data-name="Line 84" />
          <path d="M11.8 1v7.7" data-name="Line 85" />
          <path d="M33.3 1v7.7" data-name="Line 86" />
          <path d="M23.7 37h4.8a1.2 1.2 0 0 1 1.2 1.4v9h-7.2v-9a1.2 1.2 0 0 1 1.2-1.3Z" data-name="Path 14089" />
          <path d="M30.9 26.8h4.8a1.2 1.2 0 0 1 1.2 1.3v19.3h-7.2V28a1.2 1.2 0 0 1 1.2-1.3Z" data-name="Path 14090" />
          <path d="M38 32H43a1.2 1.2 0 0 1 1.2 1.2v14.2h-7.2V33.2A1.2 1.2 0 0 1 38 32Z" data-name="Path 14091" />
          <path d="M10.6 32H13" data-name="Line 87" />
        </g>
      </g>
    </g>
  </svg>
);

export const TotalMetricsIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 45.1 53.4">
    <g data-name="Group 6647">
      <g
        data-name="Group 6646"
        transform="translate(1 1)"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <rect data-name="Rectangle 1653" width="47.77" height="8.43" rx="1" />
        <path data-name="Rectangle 1654" d="M2.81 8.43h42.15v29.505H2.81z" />
        <path data-name="Line 168" d="M47.77 37.935H0" />
        <path data-name="Line 169" d="M23.885 37.935v4.215" />
        <circle data-name="Ellipse 281" cx="4.006" cy="4.006" r="4.006" transform="translate(20.03 42.731)" />
        <path data-name="Line 170" d="m20.03 21.365-6.677 5.341" />
        <path data-name="Line 171" d="m33.946 19.813-7.251 6.881" />
        <path data-name="Line 172" d="m26.707 26.706-6.677-5.341" />
        <path data-name="Path 15828" d="M34.719 24.037v-5.342h-5.342" />
      </g>
    </g>
  </svg>
);

export const ViewsIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 41.4 32.3">
    <g data-name="Group 4916">
      <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" data-name="Group 4915">
        <path d="M25 11.6a6.5 6.5 0 1 1-9.1 0 6.5 6.5 0 0 1 9.2 0" data-name="Path 13445" />
        <path d="m40 24.8-6.5 6.5L29 27" data-name="Path 13446" />
        <path
          d="M20.5 31.3c-8 0-15.3-4.3-18.5-11h0A9.4 9.4 0 0 1 2 12h0C5.2 5.3 12.5 1 20.5 1S35.7 5.3 39 12h0a9.4 9.4 0 0 1 1 4.2"
          data-name="Path 13447"
        />
      </g>
    </g>
  </svg>
);

export const WebVideoIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 29.2 29.4">
    <g data-name="Group 3367" transform="translate(.8 .8)">
      <g data-name="Group 3366">
        <g data-name="Group 3365">
          <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M11.2 13.3 18 9.4l-6.7-3.8Z"
            data-name="Path 11916"
          />
        </g>
      </g>
      <rect
        width="27.7"
        height="18.8"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        data-name="Rectangle 1017"
        rx="1.1"
      />
      <circle
        cx="2.3"
        cy="2.3"
        r="2.3"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        data-name="Ellipse 48"
        transform="translate(4.6 23.3)"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M27.7 25.6H9.2"
        data-name="Line 34"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M0 25.6h4.6"
        data-name="Line 35"
      />
    </g>
  </svg>
);

export const ConversionsIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 51.368 51.825">
    <g id="Group_6477" data-name="Group 6477" transform="translate(-2038.773 -10495.161)">
      <g id="Group_6476" data-name="Group 6476">
        <path id="Path_15797" data-name="Path 15797" d="M2039.773,10508.266h43.579" fill="none" strokeWidth="2" />
        <g id="Group_6475" data-name="Group 6475">
          <g id="Group_6474" data-name="Group 6474">
            <path
              id="Path_15798"
              data-name="Path 15798"
              d="M2087.931,10541.433l-7.263,4.193a2.422,2.422,0,0,1-2.422,0l-7.263-4.193a2.42,2.42,0,0,1-1.21-2.1v-8.56a2.422,2.422,0,0,1,1.21-2.1l7.263-4.192a2.417,2.417,0,0,1,2.422,0l7.263,4.192a2.422,2.422,0,0,1,1.21,2.1v8.56A2.421,2.421,0,0,1,2087.931,10541.433Z"
              fill="none"
              strokeWidth="2"
            />
            <path
              id="Path_15799"
              data-name="Path 15799"
              d="M2088.817,10529.565l-8.149,4.7a2.417,2.417,0,0,1-2.422,0l-8.149-4.7"
              fill="none"
              strokeWidth="2"
            />
            <line
              id="Line_153"
              data-name="Line 153"
              y1="11.358"
              transform="translate(2079.457 10534.592)"
              fill="none"
              strokeWidth="2"
            />
          </g>
        </g>
        <circle
          id="Ellipse_277"
          data-name="Ellipse 277"
          cx="1"
          cy="1"
          r="1"
          transform="translate(2047.773 10502.161)"
          fill="none"
          strokeWidth="2"
        />
        <circle
          id="Ellipse_278"
          data-name="Ellipse 278"
          cx="1"
          cy="1"
          r="1"
          transform="translate(2053.773 10502.161)"
          fill="none"
          strokeWidth="2"
        />
        <circle
          id="Ellipse_279"
          data-name="Ellipse 279"
          cx="1"
          cy="1"
          r="1"
          transform="translate(2059.773 10502.161)"
          fill="none"
          strokeWidth="2"
        />
      </g>
      <g id="Rectangle_1481" data-name="Rectangle 1481">
        <path
          id="Path_15800"
          data-name="Path 15800"
          d="M2062.446,10540.161h-11.673a11,11,0,0,1-11-11v-22a11,11,0,0,1,11-11h22a11,11,0,0,1,11,11v8"
          fill="none"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
    </g>
  </svg>
);
export const TrashCan = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 6.344 7.48">
    <g data-name="Group 13286">
      <g data-name="Group 13239">
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth=".75"
          d="M.375 1.912h5.594"
          data-name="Line 449"
        />
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth=".75"
          d="M5.569 1.911v4.4a.8.8 0 0 1-.8.8h-3.2a.8.8 0 0 1-.8-.8v-4.4"
          data-name="Path 25334"
        />
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth=".75"
          d="M4.534.375H1.809"
          data-name="Line 450"
        />
        <g data-name="Group 13236">
          <g data-name="Group 13235">
            <path
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".75"
              d="M3.918 5.255 2.425 3.762"
              data-name="Line 451"
            />
          </g>
        </g>
        <g data-name="Group 13238">
          <g data-name="Group 13237">
            <path
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth=".75"
              d="m2.425 5.255 1.493-1.493"
              data-name="Line 452"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const WarningIcon = ({ className }) => (
  <svg
    fill="#000000"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    width="800px"
    height="800px"
    viewBox="0 0 478.125 478.125"
    className={className}
  >
    <g>
      <g>
        <g>
          <circle cx="239.904" cy="314.721" r="35.878" />
          <path d="M256.657,127.525h-31.9c-10.557,0-19.125,8.645-19.125,19.125v101.975c0,10.48,8.645,19.125,19.125,19.125h31.9 c10.48,0,19.125-8.645,19.125-19.125V146.65C275.782,136.17,267.138,127.525,256.657,127.525z" />
          <path d="M239.062,0C106.947,0,0,106.947,0,239.062s106.947,239.062,239.062,239.062c132.115,0,239.062-106.947,239.062-239.062 S371.178,0,239.062,0z M239.292,409.734c-94.171,0-170.595-76.348-170.595-170.596c0-94.248,76.347-170.595,170.595-170.595 s170.595,76.347,170.595,170.595C409.887,333.387,333.464,409.734,239.292,409.734z" />
        </g>
      </g>
    </g>
  </svg>
);

export const FiltersIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 35.2 35.2">
    <g data-name="Group 6013">
      <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" data-name="Group 6012">
        <path d="M1 4.7h18.5" data-name="Path 15204" />
        <path d="M15.8 17.6h18.4" data-name="Path 15205" />
        <path d="M1 30.5h18.5" data-name="Path 15206" />
        <path d="M33.2 2a3.7 3.7 0 1 1-5.3 0 3.7 3.7 0 0 1 5.3 0" data-name="Path 15207" />
        <path d="M7.3 15a3.7 3.7 0 1 1-5.2 0 3.7 3.7 0 0 1 5.2 0" data-name="Path 15208" />
        <path d="M33.2 28a3.7 3.7 0 1 1-5.3 0 3.7 3.7 0 0 1 5.3 0" data-name="Path 15209" />
      </g>
    </g>
  </svg>
);
